<template>
  <div class="box">
    <baidu-map
      id="Map"
      class="bm-view"
      ak="QGGvEs2B684koGNEfUirzuoWUMzirbaQ"
      :center="center"
      :zoom="zoom"
      @ready="header"
    >
      <bm-driving :start="startLocation" :end="endLocation" :auto-viewport="true"></bm-driving>
      <bm-control>
        <div class="btn" @click="toggle" v-if="process">返回</div>
      </bm-control>
    </baidu-map>
  </div>
</template>

<script>
import { BmlMarkerClusterer } from "vue-baidu-map";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import bmDriving from "vue-baidu-map/components/search/Driving.vue";
import bmControl from "vue-baidu-map/components/controls/Control.vue";
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      shopTypeList: [],
      ShopClassList: [],
      shopTypeName: "",
      zoom: 14,
      show: false,
      center: { lng: 116.404, lat: 39.915 },
      startLocation: { lng: this.$store.state.log, lat: this.$store.state.lat },
      endLocation: { lng: "", lat: "" },
      positionList: [],
      a: false,
      tabList: [1, 0, 0],
      closeOnClick: false,
      tabImg: [
        {
          showNow: require("../assets/index01.png"),
          showNo: require("../assets/index02.png")
        },
        {
          showNow: require("../assets/map01.png"),
          showNo: require("../assets/map02.png")
        },
        {
          showNow: require("../assets/us01.png"),
          showNo: require("../assets/us02.png")
        }
      ],
      process: false
    };
  },
  components: {
    BaiduMap,
    BmMarker,
    BmInfoWindow,
    BmlMarkerClusterer,
    bmDriving,
    bmControl
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
     this.$store.commit("UserSelf", JSON.parse(localStorage.getItem("ZQUserSelf")));
    $("#Map>div").css({
      height: "100vh"
    });
    this.process = true;
    this.endLocation = this.$route.query.endLocation;
  },
  activated() {},
  methods: {
    toggle() {
      this.$router.go(-1);
    },
    header({ BMap, map }) {
      console.log(BMap, map);
      this.BMap = BMap;
      this.map = map;
      // 百度地图API功能
    }
  }
};
</script>
<style lang='scss' scoped>
.box {
  height: 100vh;
  display: flex;
  justify-content: flex-start;
}
.LeftBox {
  width: 1.5rem;
}
.LeftBox div {
  background-color: #f7f5f6;
  font-size: 0.26rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}
.clickType {
  background-color: white !important;
}
#Map {
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden;
}
#Map > div:nth-child(1) {
  width: 6.5rem !important;
  height: 100vh !important;
}
.btn {
  width: 1.5rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  background: cornflowerblue;
  color: white;
}
.showWindow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navigation {
  height: 100%;
  padding-right: 0.3rem;
}
</style>

